import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import routes from './routes/routes';
import LoadingBox from './components/loading/LoadingBox';
import { ReferentialProvider } from './context/ReferentialContext';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import { App as AntdApp, ConfigProvider } from 'antd';
import { useUiLocale } from './i18n/uiLocale';
import CaptureParrainage from './components/parrainage/CaptureParrainage';
import AppErrorBoundary from './components/errors/AppErrorBoundary';

const App: React.FC = () => {
  // Sens de lecture (rtl pour l'arabe) et locale antd/dayjs suivent la langue.
  const { direction, antdLocale } = useUiLocale();

  return (
    <Suspense fallback={<LoadingBox />}>
      <I18nextProvider i18n={i18n}>
        <ConfigProvider direction={direction} locale={antdLocale}>
          <AntdApp>
            {/* Erreur de rendu (ex. chunk disparu après un déploiement) :
                écran de repli au lieu d'une page blanche. */}
            <AppErrorBoundary fullPage>
              <Router
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                {/* Lien de parrainage (?ref=CODE), capté sur toute page. */}
                <CaptureParrainage />
                <AuthProvider>
                  <ReferentialProvider>
                    <Routes>
                      {routes.map((route, index) => {
                        const { path, element, isProtected, requiredRoles } = route;
                        const wrappedElement = isProtected ? (
                          <ProtectedRoute requiredRoles={requiredRoles}>
                            {element}
                          </ProtectedRoute>
                        ) : (
                          element
                        );
                        return (
                          <Route
                            key={index}
                            path={path}
                            element={wrappedElement}
                          />
                        );
                      })}
                    </Routes>
                  </ReferentialProvider>
                </AuthProvider>
              </Router>
            </AppErrorBoundary>
          </AntdApp>
        </ConfigProvider>
      </I18nextProvider>
    </Suspense>
  );
};

export default App;
